import { useQuery } from '@tanstack/react-query'

import type { ClientSearchResult } from '../../../types/client.js'

import { apiClient } from '../../../lib/client.js'
import { estimateKeys } from './keys.js'

export const useSearchClientsQuery = (query: string, clientType?: 'COMPANY' | 'INDIVIDUAL') =>
  useQuery({
    enabled: query.length >= 2,
    queryFn: async () => {
      const response = await apiClient.client.get<ClientSearchResult[]>(`/client/search`, {
        params: clientType ? { clientType, q: query } : { q: query },
      })
      return response.data
    },
    queryKey: estimateKeys.clientSearch(query, clientType),
  })
